import { app } from '../../../../../app';

app.service('AddNewSharedPasswordModal', modal);

/** @ngInject */
function modal($uibModal) {
    return publicServices => $uibModal.open({
        component: 'companySharingCenterSharedPasswordsAdd',
        resolve: {publicServices: () => publicServices},
    }).result
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/add/add-shared-password.modal.js